import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80 dark:bg-secondary/90 dark:text-secondary-foreground",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground dark:border-gray-500",
        success:
          "border-transparent bg-green-600 text-white hover:bg-green-600/80 dark:bg-green-500",
        blue:
          "border-transparent bg-blue-600 text-white hover:bg-blue-600/80 dark:bg-blue-500",
        purple: 
          "border-transparent bg-purple-600 text-white hover:bg-purple-600/80 dark:bg-purple-500",
        orange: 
          "border-transparent bg-orange-500 text-white hover:bg-orange-500/80 dark:bg-orange-500",
        amber: 
          "border-transparent bg-amber-400 text-amber-900 hover:bg-amber-400/80 dark:bg-amber-500 dark:text-white",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
